<template>
  <div class="main-section">
    <div class="content">
      <div class="navigation-bar">
        <div class="navigation-bar-menus">
          <ul>
            <!-- <li><a class="sidebar-active">setup</a></li> -->
            <li><router-link to="contacts">Contacts</router-link></li>
            <!-- <li><router-link to="customforms">Custom Forms</router-link></li> -->
            <li>
              <router-link to="autoresponse" class="sidebar-active"
                >Auto Response</router-link
              >
            </li>
            <!-- <li><router-link to="campaign">Auto Campaign</router-link></li> -->
            <li><router-link to="bulksms">BulkMan 1.2</router-link></li>
          </ul>
        </div>
      </div>
      <!-- eo page navigation bar -->

      <div class="main-content">
        <div class="quick-response content-here" id="qrs">
          <el-card>
            <div class="tabnpill">
              <ul class="nav nav-tabs">
                <li class="active">
                  <a data-toggle="tab" href="#QuickResponse"
                    >Auto Response sms</a
                  >
                </li>
                <!-- <li><a data-toggle="tab" href="#History">History</a></li> -->
              </ul>

              <div class="tab-content">
                <div id="QuickResponse" class="tab-pane fade in active">
                  <qrs-input></qrs-input>
                </div>

                <!-- <div id="History" class="tab-pane fade">
                            <call-history></call-history>
                        </div> -->
              </div>
            </div>
          </el-card>
        </div>
        <!-- eo quick response sms and history -->
      </div>
      <!-- end of main content -->
    </div>

    <div class="footer">
      <p>© ekghanti 2020</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qrs from "./../parts/qrs.vue";
import clh from "./../parts/callhistory.vue";

export default {
  components: {
    "qrs-input": qrs,
    "call-history": clh
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subpages/autoresponse.vue